export const getCurrentSchoolYearStart = (today = new Date()) => {
  const year = today.getMonth() >= 8 ? today.getFullYear() : today.getFullYear() - 1;

  return `${year}-09-01`;
};

export const getDefaultSchoolClassesFilters = (today = new Date()) => ({
  search: "",
  dayOfWeek: "",
  classTypeId: "",
  startTime: "",
  endTime: "",
  teacherId: "",
  showOnlyNotRepeating: false,
  showOnlyRepeating: false,
  fromDate: getCurrentSchoolYearStart(today),
  tillDate: "",
  comment: false,
});
